import React from 'react';
import { Box, Typography, Container, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const faqs = [
  {
    question: "Aliquam amet dui adipiscing mi consectetur ipsum sem laoreet dolor.",
    answer: "Facilisis risus ipsum ultricies scelerisque ullamcorper felis mi. Malesuada dictum lectus lacus imperdiet. Enim cursus magna aliquam sit malesuada purus a ac. Id in sit eu eu mus. In facilisis sollicitudin urna, at pellentesque morbi. Non posuere tincidunt faucibus amet. Ultricies vestibulum, bibendum lacus auctor porttitor fermentum malesuada massa elit."
  },
  {
    question: "Pretium sit in id felis accumsan integer tristique ut sapien.",
    answer: "Tellus vivamus enim venenatis suspendisse et aliquam ut iaculis proin. Nunc diam metus posuere et, et vulputate massa. Pharetra arcu, ullamcorper sit viverra hac a odio augue. Cursus nec quis lectus nibh aliquam diam ac vulputate. Consequat non turpis praesent aliquam eget vel integer. Aliquam semper amet urna maecenas amet."
  },
  {
    question: "Malesuada consequat risus, scelerisque neque, nisi dignissim blandit.",
    answer: "At convallis cras enim ipsum vitae."
  },
  {
    question: "Non, nisl, tellus a porttitor eget sed consequat sed.",
    answer: "Adipiscing nec lorem turpis integer congue venenatis netus consequat magna."
  },
  {
    question: "Lacus, elementum leo imperdiet etiam metus a commodo ac.",
    answer: "Arcu enim cras fames nunc, elementum quis quam enim."
  }
];

const viewportConfig = { triggerOnce: false, rootMargin: "-100px 0px -100px 0px" };

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      staggerChildren: 0.09
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const FAQSection = () => {
  const [ref, inView] = useInView(viewportConfig);

  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      sx={{ 
        width: '100%',
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 4 }
      }}
    >
      <Container maxWidth="lg" sx={{px:'0!important'}}>
        <Typography 
          component={motion.div}
          variants={itemVariants}
          variant="h4" 
          sx={{ 
            textAlign: 'left', 
            color: '#64B5F6',
            fontWeight: 'bold',
            mb: 6,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              bottom: -10,
              width: '80px',
              height: '4px',
              background: 'linear-gradient(to right, #64B5F6, transparent)',
              borderRadius: '2px'
            }
          }}
        >
          FAQs
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2,px:2 }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              component={motion.div}
              variants={itemVariants}
              sx={{
                '&:before': { display: 'none' },
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: '8px !important',
                '&.MuiAccordion-root': {
                  borderRadius: '8px',
                  overflow: 'hidden'
                }
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  backgroundColor: '#F5F5F5',
                  '&:hover': {
                    backgroundColor: '#EEEEEE'
                  }
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ color: '#666' }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQSection; 